//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: 'PostTypeModal',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '岗位类型表表单',
      tableName: 'sys_post_type',
      form_fields: ['postCode', 'postName', 'component', 'homeUrl', 'status', 'sort'],
      form_fields_time: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 12
        }
      },
      validatorRules: {
        postName: {
          rules: [{
            required: true,
            message: '请输入岗位类型名称!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};